<template>
  <el-dialog
    class="radish-dia"
    title="面试反馈"
    top="70px"
    :modal="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="dialogVisible"
  >
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="选择面试">
        <el-select v-if="mianReady" v-model="interId" filterable @change="changeInt">
          <el-option v-for="item in interviews" :key="item._id" :label="item.round + '面'" :value="item._id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="候选人"> <el-input v-model="form['候选人']" disabled></el-input> </el-form-item>
      <el-form-item label="顾问"> <el-input v-model="form['顾问']" disabled></el-input> </el-form-item>
      <el-form-item label="面试官"> <el-input v-model="form['面试官']"></el-input> </el-form-item>
      <el-form-item label="面试时长"> <el-input v-model="form['面试时长']"></el-input> </el-form-item>
      <el-form-item label="沟通情况"> <el-input v-model="form['沟通情况']" type="textarea"></el-input> </el-form-item>
      <el-form-item label="意向"> <el-input v-model="form['意向']"></el-input> </el-form-item>
      <el-form-item label="诉求"> <el-input v-model="form['诉求']"></el-input> </el-form-item>
      <el-form-item label="目前薪酬"> <el-input v-model="form['目前薪酬']"></el-input> </el-form-item>
      <el-form-item label="目前职级"> <el-input v-model="form['目前职级']"></el-input> </el-form-item>
      <el-form-item label="备注"> <el-input v-model="form['面试反馈备注']" type="textarea"></el-input> </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data: function() {
    return {
      dialogVisible: false,
      form: {},
      interviews: [],
      interId: '',
      mianReady: false,
    }
  },
  methods: {
    show: async function(row, pid) {
      this.form = {}
      const res = await app.service('radish').findInterview({ rid: row.rid, pid: pid })
      if (res.data.length == 0) {
        this.$alert('还没有安排面试', { showClose: false })
        return
      }
      this.interviews = res.data
      const interview = res.data[0]
      this.interId = interview._id
      this.setForm(interview)
      this.mianReady = true
      this.dialogVisible = true
    },
    setForm: function(interview) {
      this.form = interview
    },
    changeInt: function() {
      const intArr = this.interviews.filter(i => i._id == this.interId)
      this.setForm(intArr[0])
    },
    handleConfirm: async function() {
      const dt = JSON.parse(JSON.stringify(this.form))
      const newDt = {
        候选人: dt.候选人,
        顾问: dt.顾问,
        面试官: dt.面试官,
        面试时长: dt.面试时长,
        沟通情况: dt.沟通情况,
        意向: dt.意向,
        诉求: dt.诉求,
        目前薪酬: dt.目前薪酬,
        目前职级: dt.目前职级,
        备注: dt.备注,
      }
      const res = await app.service('radish').modifyInterview({ _id: this.interId, data: newDt })
      if (res.status == 'success') {
        this.$message.success({ duration: 500, message: '反馈成功' })
      } else {
        this.$message.error(res.msg)
      }
      this.dialogVisible = false
    },
  },
}
</script>
